import { render, staticRenderFns } from "./guestsSeminar.vue?vue&type=template&id=4d232d1e&"
import script from "./guestsSeminar.vue?vue&type=script&lang=js&"
export * from "./guestsSeminar.vue?vue&type=script&lang=js&"
import style0 from "./guestsSeminar.vue?vue&type=style&index=0&id=4d232d1e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports